<template>
  <div class="profile">
    <section class="profile__header">
      <div class="profile__header__content">
        <div class="profile__header__content__center">
          <div class="profile__header__content__avatar">
            <img class="avatar" :src="userAvatar" alt="">
            <div v-if="profilePath">
            <router-link to="/home/profile/edit" class="edit-icon"><img src="static/images/edit_icon.svg" alt=""></router-link>
            </div>
            <span class="name">{{ userDetails.username }}</span>
            <span class="name msisdn_num" v-if="showMsisdnInProfilePage">{{ userDetails.msisdn }}</span>
          </div>
        </div>
      </div>
    </section>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'profile',
  created() {
    this.setProfilePath(true);
  },
  methods: {
    ...mapMutations('common', [
      'setProfilePath',
    ]),
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'userAvatar',
      'profilePath',
      'showMsisdnInProfilePage',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/Profile.vue